import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';

export default class About extends React.Component {
  render() {
    return (
     <section>
      <Header {...this.props} /> 
      <div className="container has-text-centered">
       <section className="section">
          <div className="container">
            <h1 className="title is-3" style={{ marginBottom: '3rem' }}>About Us</h1>
            <div className="content has-text-left">
              <p>The Collaborative Care Initiative (CCI) was founded by Gary Sachs, MD to enhance the care of individuals seeking a collaborative systematic approach to treatment for complex psychiatric conditions. In 1986, Dr Sachs also founded the Bipolar Clinic and Research Program at Massachusetts General hospital and served as Principle Investigator for the NIMH's Systematic Treatment Enhancement Program for Bipolar Disorder (STEP-BD) . His career has focused on developing innovative approaches approaches to clinical practice and patient centered research. &nbsp;</p>
              <p>CCI's approach aims to optimize the benefit of treatment and improve quality of life.&nbsp; We do this by helping engaged patients and their care providers achieve “concordance” and to increase the rate of wise amicable decision making.</p>
              <p>The CCI's Engaged Practice platform provides Measure-based guidance, assessment methods, and informational resources, which enable patients and their care providers to systematically pursue an individualized care plan.&nbsp; The Engaged Practice platform will also use de-identified datasets to address questions posed by patients regarding the comparative effectiveness of commonly used treatments and self-management strategies.</p>
            </div>
          </div>
        </section>          
      </div>
    </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/About.js